const chart_options = {
  region: 'world',
  legend: 'none',
  displayMode: 'markers', //region
  colorAxis: {
    colors: ['green', 'green'],
  },

  backgroundColor: {
    strokeWidth: '0' /* control the countries borders width */,
    stroke: 'lightgray',
  },
  datalessRegionColor: 'lightgray',
  resolution: 'countries',
  height: 360,
  forceFrame: true,
  enableRegionInteractivity: false,
  magnifyingGlass: {enable: true, zoomFactor: 7.5},
  tooltip: {
    isHtml: true,
  },
};

export default chart_options;
